export default __webpack_public_path__ + "static/media/aaaaa.e94fec52.jpg";